/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import Dropdown from '../components/menus/Dropdown';

// defines the prop definitions for NotifictionRowsOption...
export interface Options {
  label: string;
  value: string;
  disabled?: boolean;
};

// defines the prop definitions for NotifictionRowsChooser...
export interface NotifictionProps {
  onChange?: Function;
  fieldLabel?: string;
  defaultValue?: string;
  readOnly?: boolean;
  required?: boolean;
  hasError?: boolean;
  placeholder?: string;
};

// defines the styles used by NotifictionRowsChooser chooser ...
const useStyles = makeStyles(theme => ({
  root : {
    padding : '0px !important',
    margin  : '0px !important'
  }
}));

/**
 * Generates the Notifiction options list ...
 */
function getOptions() {
  const notifictionOptions =  [];
  const notifictionMap = translate('common:editors.preferences.notification.pages', {returnObjects: true});
  notifictionMap?.map(({value}) => {
    notifictionOptions?.push({label: value, value});
  });
  return notifictionOptions;
};

/**
 * Allows user to choose a preferred Notifiction rows per page from one of the available/supported
 * Notifictions.
 *
 * ```typescript
 * import {NotifictionRowsChooser} from '@ion/dls/src/editors/NotifictionRowsChooser';
 *
 * <NotifictionRowsChooser options={options}
 *   fieldLabel={translate('common:Notifictions.fieldLabel')}
 *   defaultValue='default'
 *   hasError={true}
 *   includeDefault={false}
 *   readOnly={false}
 *   onChange={handleChange} />
 *
 * ```
 */
export const NotifictionRowsChooser = ({
  onChange,
  placeholder,
  defaultValue,
  fieldLabel = '',
  required = false,
  hasError = false,
  readOnly = false
}: NotifictionProps) => {
  const classes                 = useStyles();
  const [selected, setSelected] = useState<string>(defaultValue || null);
  const options: Options[]      = getOptions();

  const handleChange = (value) => {
    setSelected(value);
    onChange(value);
  };

  return (
    <div className={classes.root}>
      <Dropdown required={required}
        options={options}
        autoComplete={false}
        placeholder={placeholder}
        fieldLabel={fieldLabel}
        hasError={hasError}
        disabled={readOnly}
        value={selected}
        labelAsValue={false}
        onChange={function({target}) {
          handleChange(target.value as string);
        }}/>
    </div>
  );
};

export default NotifictionRowsChooser;
